import { render, staticRenderFns } from "./TenantManagement.vue?vue&type=template&id=14441888&scoped=true"
import script from "./TenantManagement.vue?vue&type=script&lang=js"
export * from "./TenantManagement.vue?vue&type=script&lang=js"
import style0 from "./TenantManagement.vue?vue&type=style&index=0&id=14441888&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14441888",
  null
  
)

export default component.exports